/* QuoteBorder - migrated to Tailwind */
export const quoteBorderClassName =
  "flex justify-around items-center my-[7px] -mx-2.5 h-[30px] [&_svg]:w-[30px] [&_svg]:h-[30px] [&_svg]:mx-[17px] [&_span]:h-px [&_span]:bg-[#e2e2e2] [&_span]:flex-grow";
